module.exports = __webpack_public_path__ + "img/14_17.739e966a.png";